import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X, Sparkles } from "lucide-react";

interface GuestModeBannerProps {
  onDismiss?: () => void;
}

export const GuestModeBanner = ({ onDismiss }: GuestModeBannerProps) => {
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
    onDismiss?.();
  };

  return (
    <div className="bg-gradient-to-r from-amber-500 to-yellow-500 text-black px-4 py-3 relative">
      <div className="container mx-auto flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 flex-1">
          <Sparkles className="h-5 w-5 flex-shrink-0" />
          <p className="text-sm font-medium">
            <span className="font-bold">You're exploring a preview!</span>{" "}
            <span className="hidden sm:inline">Create a free account to unlock the full experience with personalized readings and rewards.</span>
            <span className="sm:hidden">Sign up to unlock the full experience.</span>
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={() => navigate('/register')}
            size="sm"
            className="bg-black text-white hover:bg-black/80 font-semibold"
          >
            Create Free Account
          </Button>
          <button
            onClick={handleDismiss}
            className="p-1 hover:bg-black/10 rounded-full transition-colors"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
